function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import curry from 'ramda/src/curry';
import equals from 'ramda/src/equals';
import innerJoin from 'ramda/src/innerJoin';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import none from 'ramda/src/none';
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import propEq from 'ramda/src/propEq';
import values from 'ramda/src/values';
import i18n from 'invision-core/src/components/i18n/i18n';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { MetadataCodeLoadedSelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { OFFER_STATUS_INDICATOR_STATUS } from 'invision-core/src/constants/status.constants';
import { LanguageSelector, UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { CurrentCustomerSelector, RouteParams } from '../../../../../../../../reducers/selectors/customer.selectors';
import { IsCreatingModeSelector, IsModifyingModeSelector, IsReplacingModeSelector } from '../../../create.products.order.wizard.selectors';
import { CouponCodesSelector, HasSavedSeason, HasOtherSavedSeasonSelections, HaveSelectedProductMetadata, IncludedEpisodesSelector, IncludedProductsSelector, IndividualEpisodesConfigurationViewModelSelector, InvalidItemsSelector, IsCalculatingQuoteSelector, IsFetchingOrderableProductData, IsFetchingSingleProductContext, IsSelectedProductAdHoc, IsSelectedProductSeriesContainer, IsSelectedProductDbss, IsSelectedProductServiceFeature, OptionalProductsConfigurationViewModelSelector, OtherSeasonSelectionCount, OtherSeasonsProductsToAdd, PicklistProductsConfigurationViewModelSelector, PicklistSelectionMessageSelector, ProductDialogErrorMessagesSelector, ProductsWithMetadataMapSelector, RemainingEpisodicProductIdsSelector, ReplaceCartItemSelector, SavedOtherSeasonSelections, SearchCouponCodeSelector, SelectedCartItemPricingPlanIdSelector, SelectedCartItemQuantitySelector, SelectedProductGuidanceRatingsSelector, SelectedProductSelector, SelectedProductIdSelector, SelectedProductDescriptionSelector, SelectedSeriesContainerProductId, SelectedShoppingCartItemIndexSelector, SeriesContainerEpisodicBundlesOptions, SeriesContainerIncludedEpisodicBundles, ShoppingCartSelector, SubmitChangeOfServiceForServiceFeatureRequestSelector } from '../../../../../../../../reducers/selectors/products.order.selectors';
import { getPricingPlanAvailabilityDate } from '../../../../../../../../reducers/helpers/products.order.selector.helpers';
import { CurrentSubscriptionSelector, EditSubscriptionItemSelector, InstancePropertySelector, PricingPlanOptionsSelector, SubscriptionPricingPlanIdSelector } from '../../../../../../../../reducers/selectors/customer.subscriptions.selectors';
import { ChangeImmediateSelector, CurrentStepSelector, FeatureOrderProductPricingPlanQuantitySelector, PaymentInstrumentIdsSelector } from '../../../../../../../../reducers/selectors/products.wizard.selectors';
import { OrdersSelector } from '../../../../../../../../reducers/selectors/order.history.selectors';
import { addToAndUpdateShoppingCart, addMultipleAndUpdateShoppingCart, calculateModifyOrderQuote, editAndUpdateShoppingCart, editMultipleAndUpdateShoppingCart, setShoppingCartItemIndex, updateServiceFeatureQuantityPromise } from '../../../../../../../../reducers/actions/products.wizard.actions';
import LocaleKeys from '../../../../../../../../locales/keys';
import { clearSavedSeasonsSelections, clearSelectedOptions, clearShoppingCartError, getOrderablePricingExtended, getProductMetadataBatch, loadAdditionalEpisodes, saveSeriesContainerSeasonSelections, setEpisodes, setOptionalProducts, setPicklistProducts, setProductOrderCouponCodes, setReplacementItem, setSelectedProductId, setSelectedSeriesContainerProductId, setSelectedSeriesContainerSeasons } from '../../../../../../../../reducers/actions/products.order.actions';
import { DBSS_UPDATE_CART_ADDITIONAL_OPTIONS, GIFT_CARD_INSTANCE_PROPERTY_NAMES } from '../../../../../../../../reducers/constants/products.wizard.constants';
import { pascalCaseKeys } from '../../../../../../../../utilities/object.formatting.helper';
import { getEditItems, getReplaceItems, noItemsModified } from '../../../subscriptionHelpers/subscription.order.helper';
import { MAX_SERVICE_FEATURE_ITEMS } from '../../../../../../../../customercare.constants';
import { STRUCTURE_TYPES } from '../../../../../../../../reducers/constants/structure.type.constants';
import { processServiceFeatures, splitIndividualProducts } from './product.dialog.helpers';
import { AD_HOC_OVERRIDE, PRICE_OVERRIDE_ACCESS } from '../../../../../../../../security.attributes';
import { EMPTY_OBJECT } from 'invision-core/src/constants/common.constants';
var DESCRIPTION_LENGTH_LIMIT = 400;
var FAILED_CALL = 'FAILED_CALL';
var TAB_INDEX = {
  DETAILS: 0,
  OPTIONS: 1
};
var ITV_QUANTITY = {
  MIN: 1,
  MAX: 100
};

// TODO - Customer Order refactor this dialog options tab to consume presentational components for option pricing DBSS vs ITV
var ProductDialogController = /*#__PURE__*/function () {
  function ProductDialogController($filter, $ngRedux, $timeout, uiNotificationService, $anchorScroll) {
    _classCallCheck(this, ProductDialogController);
    Object.assign(this, {
      $anchorScroll: $anchorScroll,
      $filter: $filter,
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      _addedProducts: [],
      coreLocaleKeys: CoreLocaleKeys,
      countOfSelectedPricingPlans: {},
      descriptionLengthLimit: DESCRIPTION_LENGTH_LIMIT,
      formSubmittedFromOptionsTab: false,
      hasIncludedWithInstanceProperties: false,
      hasIncludedWithoutInstanceProperties: false,
      includedProductInstanceProperties: {},
      isExceededCartMaximumQuantity: false,
      ITV_QUANTITY: ITV_QUANTITY,
      LocaleKeys: LocaleKeys,
      MAX_SERVICE_FEATURE_ITEMS: MAX_SERVICE_FEATURE_ITEMS,
      modalCartItemTotal: 0,
      NOW_DATETIME_ISOSTRING: new Date().toISOString(),
      picklistMessage: null,
      productClassifications: PRODUCT_CLASSIFICATIONS,
      productHasOverrides: false,
      quantity: 1,
      savedServiceFeatureModel: EMPTY_OBJECT,
      selectedIndividualEpisodes: null,
      selectedOptionalItems: null,
      selectedPicklistItems: [],
      selectedPricingPlanId: null,
      selectIndividualEpisodes: false,
      selectedEpisodicBundle: 0,
      shoppingCartForServiceFeatures: [],
      showDescriptionOverflow: false,
      TAB_INDEX: TAB_INDEX,
      tabs: [{
        name: i18n.translate(LocaleKeys.PRODUCT_OPTIONS.DETAILS),
        active: true
      }, {
        name: i18n.translate(LocaleKeys.PRODUCT_OPTIONS.OPTIONS),
        active: false
      }],
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ProductDialogController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this,
        _this$state$editSubsc,
        _this$state$editSubsc2;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          availableSeasons: SeriesContainerIncludedEpisodicBundles(store),
          changeImmediately: ChangeImmediateSelector(store),
          couponCodes: CouponCodesSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentStep: CurrentStepSelector(store),
          currentSubscription: CurrentSubscriptionSelector(store),
          editSubscriptionItem: EditSubscriptionItemSelector(store),
          featureOrderQuantities: FeatureOrderProductPricingPlanQuantitySelector(store),
          hasSavedSeason: HasSavedSeason(store),
          hasOtherSavedSeasonSelections: HasOtherSavedSeasonSelections(store),
          haveSelectedProductMetadata: HaveSelectedProductMetadata(store),
          includedEpisodes: IncludedEpisodesSelector(store),
          includedProducts: IncludedProductsSelector(store),
          individualEpisodeConfiguration: IndividualEpisodesConfigurationViewModelSelector(store),
          invalidItems: InvalidItemsSelector(store),
          isCalculatingQuote: IsCalculatingQuoteSelector(store),
          isCreatingMode: IsCreatingModeSelector(store),
          isFetchingOrderableProductData: IsFetchingOrderableProductData(store),
          isFetchingSingleProductContext: IsFetchingSingleProductContext(store),
          isModifyingMode: IsModifyingModeSelector(store),
          isReplacingMode: IsReplacingModeSelector(store),
          isSelectedProductAdHoc: IsSelectedProductAdHoc(store),
          isSelectedProductServiceFeature: IsSelectedProductServiceFeature(store),
          isSelectedProductDbss: IsSelectedProductDbss(store),
          isSelectedProductSeriesContainer: IsSelectedProductSeriesContainer(store),
          language: LanguageSelector(store),
          optionalProductConfiguration: OptionalProductsConfigurationViewModelSelector(store),
          orders: OrdersSelector(store),
          otherSeasonSelectionCount: OtherSeasonSelectionCount(store),
          otherSeasonsProductsToAdd: OtherSeasonsProductsToAdd(store),
          paymentInstrumentIds: PaymentInstrumentIdsSelector(store),
          picklistMessage: PicklistSelectionMessageSelector(store),
          picklistProductConfiguration: PicklistProductsConfigurationViewModelSelector(store),
          pricingPlansForModifySubscription: PricingPlanOptionsSelector(store),
          productDialogErrorMessages: ProductDialogErrorMessagesSelector(store),
          productsWithMetadataMap: ProductsWithMetadataMapSelector(store),
          remainingEpisodicProductIds: RemainingEpisodicProductIdsSelector(store),
          replaceItem: ReplaceCartItemSelector(store),
          routeParams: RouteParams(store),
          savedOtherSeasonSelections: SavedOtherSeasonSelections(store),
          searchCouponCode: SearchCouponCodeSelector(store),
          selectedProduct: SelectedProductSelector(store),
          selectedProductId: SelectedProductIdSelector(store),
          selectedProductDescription: SelectedProductDescriptionSelector(store),
          selectedProductGuidanceRatings: SelectedProductGuidanceRatingsSelector(store),
          selectedSeriesContainerProductId: SelectedSeriesContainerProductId(store),
          selectedShoppingCartItemIndex: SelectedShoppingCartItemIndexSelector(store),
          selectedCartItemPricingPlanId: SelectedCartItemPricingPlanIdSelector(store),
          selectedCartItemQuantity: SelectedCartItemQuantitySelector(store),
          seriesEpisodicBundles: SeriesContainerEpisodicBundlesOptions(store),
          shoppingCart: ShoppingCartSelector(store),
          structureTypes: MetadataCodeTypeSelector(CODES.StructureType, store),
          structureTypesLoaded: MetadataCodeLoadedSelector(CODES.StructureType, store),
          submitChangeOfServiceForServiceFeatureRequest: SubmitChangeOfServiceForServiceFeatureRequestSelector(store),
          subscriptionInstanceProperties: InstancePropertySelector(store),
          subscriptionPricingPlanId: SubscriptionPricingPlanIdSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        addToAndUpdateShoppingCart: addToAndUpdateShoppingCart,
        addMultipleAndUpdateShoppingCart: addMultipleAndUpdateShoppingCart,
        calculateModifyOrderQuote: calculateModifyOrderQuote,
        clearSavedSeasonsSelections: clearSavedSeasonsSelections,
        clearSelectedOptions: clearSelectedOptions,
        clearShoppingCartError: clearShoppingCartError,
        editAndUpdateShoppingCart: editAndUpdateShoppingCart,
        editMultipleAndUpdateShoppingCart: editMultipleAndUpdateShoppingCart,
        fetchCodeTypes: fetchCodeTypes,
        loadAdditionalEpisodes: loadAdditionalEpisodes,
        getOrderablePricingExtended: getOrderablePricingExtended,
        getProductMetadataBatch: getProductMetadataBatch,
        saveSeriesContainerSeasonSelections: saveSeriesContainerSeasonSelections,
        setEpisodes: setEpisodes,
        setOptionalProducts: setOptionalProducts,
        setPicklistProducts: setPicklistProducts,
        setProductOrderCouponCodes: setProductOrderCouponCodes,
        setReplacementItem: setReplacementItem,
        setSelectedProductId: setSelectedProductId,
        setSelectedSeriesContainerProductId: setSelectedSeriesContainerProductId,
        setSelectedSeriesContainerSeasons: setSelectedSeriesContainerSeasons,
        setShoppingCartItemIndex: setShoppingCartItemIndex,
        updateServiceFeatureQuantityPromise: updateServiceFeatureQuantityPromise
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
        _this._initializeOrUpdateComponentData();
      });
      this._instanceProperties = clone(this.state.subscriptionInstanceProperties || this.state.selectedProduct.InstanceProperties) || {};
      this.handleTabSelection = function (selectedTab) {
        _this._selectTab(selectedTab);
      };
      this._selectTab(this._getTabByNameOrDefault(this.selectedTab));
      if (!this.state.structureTypesLoaded) {
        this.actions.fetchCodeTypes(CODES.StructureType);
      }
      this.hasAdHocOverrideAccess = hasAccess(this.state.userSecurityAttributes, AD_HOC_OVERRIDE);
      this.hasPriceOverrideAccess = hasAccess(this.state.userSecurityAttributes, PRICE_OVERRIDE_ACCESS);
      if (this.state.selectedShoppingCartItemIndex !== null) {
        // zero value is true for selectedShoppingCartItemIndex
        this.quantity = clone(this.state.selectedCartItemQuantity);
        this.selectedPricingPlanId = clone(this.state.selectedCartItemPricingPlanId);
        this.isEditMode = this.state.shoppingCart && this.itemExistsInCart() ? true : false;
      }
      if (this.state.subscriptionPricingPlanId && this.isModifyMode()) {
        this.selectedPricingPlanId = clone(this.state.subscriptionPricingPlanId);
      }
      if ((_this$state$editSubsc = this.state.editSubscriptionItem) !== null && _this$state$editSubsc !== void 0 && (_this$state$editSubsc2 = _this$state$editSubsc.ChangePricingPlan) !== null && _this$state$editSubsc2 !== void 0 && _this$state$editSubsc2.Id && this.isModifyMode()) {
        this.selectedPricingPlanId = this.state.editSubscriptionItem.ChangePricingPlan.Id;
      }

      // Skip RPC and Product metadata call for product that has already been visited, response of these call don't change often
      // On destroy of this component we are reinitializing the product order store which will cause this to remake this call
      // While in the product order flow this will prevent making repeated and unneeded RPC and Metadata calls
      if (!this.state.haveSelectedProductMetadata) {
        this.actions.getOrderablePricingExtended(this.state.selectedProductId, this.state.currentCustomer.Id, this.state.searchCouponCode, this.state.routeParams.serviceTypeId).then(function () {
          _this.initializeData();
          if (_this.pricingPlans) {
            _this.checkPricingPlansInstances();
          }
          var dialogPopulatedCallbackFn = _this.onDialogPopulated();
          var childProductIds = _this._getBundleProductIds();
          if (childProductIds.length) {
            _this.actions.getProductMetadataBatch(childProductIds).then(function () {
              dialogPopulatedCallbackFn && dialogPopulatedCallbackFn();
            });
          } else {
            dialogPopulatedCallbackFn && dialogPopulatedCallbackFn();
          }
        }).catch(function (error) {
          _this.uiNotificationService.transientError(error.translatedMessage);
          var failureCallbackFn = _this.onFailure();
          failureCallbackFn && failureCallbackFn();
        });
      } else {
        this.initializeData();
        if (this.pricingPlans) {
          this.checkPricingPlansInstances();
        }
        var dialogPopulatedCallbackFn = this.onDialogPopulated();
        dialogPopulatedCallbackFn && dialogPopulatedCallbackFn();
      }
      this.pricingPlanQuantityChanged = function () {
        return function (quantity, pricingPlanId, pricingPlanName, shoppingCartItemBillerRuleDetails) {
          _this.enableAddToCartButton(quantity, pricingPlanId, pricingPlanName, shoppingCartItemBillerRuleDetails);
        };
      };
      this.pricingPlanQuantityChangedByProductOrder = curry(function (pricingPlanId, quantity) {
        _this.enableAddToCartButton(quantity, pricingPlanId.Id);
      });
    }
  }, {
    key: "enableAddToCartButton",
    value: function enableAddToCartButton(quantity, pricingPlanId, pricingPlanName, shoppingCartItemBillerRuleDetails) {
      var _this2 = this;
      // TODO (CustomerOrder): OnChange should call an action to update the model
      // Move logic to a selector also and use the MaxQuantity constant that applies to all dbss carts
      this.modalCartItemTotal = 0;
      var product = {
        productId: this.state.selectedProductId,
        pricingPlanId: pricingPlanId,
        childItems: [],
        quantity: quantity
      };
      this.pricingPlans.forEach(function (currentPricingPlan) {
        if (currentPricingPlan.Id === pricingPlanId) {
          _this2.countOfSelectedPricingPlans[pricingPlanId] = convertStringToNumber(quantity);
          currentPricingPlan.cartQuantity = convertStringToNumber(quantity);
          currentPricingPlan.ShoppingCartItemBillerRuleDetails = shoppingCartItemBillerRuleDetails;
        }
        _this2.modalCartItemTotal += currentPricingPlan.cartQuantity;
      });
      this.isExceededCartMaximumQuantity = this.modalCartItemTotal > this.state.selectedProduct.MaxNonBulkQuantity || (this.state.selectedProduct.ProductContext.ServiceFeatureCardinality ? this.modalCartItemTotal > this.state.selectedProduct.ProductContext.ServiceFeatureCardinality.MaximumQuantity : false);
      var itemExistsInCart = this.shoppingCartForServiceFeatures && this.shoppingCartForServiceFeatures.length ? this.shoppingCartForServiceFeatures.find(function (item) {
        return item.pricingPlanId === pricingPlanId;
      }) : null;
      if (itemExistsInCart) {
        itemExistsInCart.quantity = quantity;
      } else {
        this.shoppingCartForServiceFeatures.push(product);
      }
    }
  }, {
    key: "checkPricingPlansInstances",
    value: function checkPricingPlansInstances() {
      this.countOfSelectedPricingPlans = this.pricingPlans.reduce(function (countPrim, selectedPricingPlan) {
        countPrim[selectedPricingPlan.Id] = selectedPricingPlan.cartQuantity;
        return countPrim;
      }, {});
    }

    // TODO - Customer Order a lot of this needs to be moved into selectors instead of controller logic that is repeatedly called
    // also we should never be modifying state from a selector in controller code like mappedPricingPlan is below
  }, {
    key: "initializeData",
    value: function initializeData() {
      if (this.selectedPricingPlanId) {
        if (!isNil(this.state.optionalProductConfiguration)) {
          this.state.optionalProductConfiguration.mappedPricingPlanId = this.selectedPricingPlanId;
        }
        if (!isNil(this.state.picklistProductConfiguration)) {
          this.state.picklistProductConfiguration.mappedPricingPlanId = this.selectedPricingPlanId;
        }
      }
      if (this.state.isSelectedProductServiceFeature) {
        this.isEditMode = this._isServiceFeatureInEditMode();
      }
      this.removeSelectedPlanIfNotAvailable();
      this.pricingPlans = this.getPricingPlans();
      this._setDefaultValuesForInstanceProperties();
      this.actions.setSelectedSeriesContainerProductId(this.state.selectedProduct.StructureType === STRUCTURE_TYPES.SERIES_CONTAINER ? this.state.selectedProduct.Id : null);

      // No Options tab for series container structure type, long term we need to move this into selectors to build the tabs
      if (this.state.selectedProduct.StructureType === STRUCTURE_TYPES.SERIES_CONTAINER) {
        this.tabs.pop();
        this._selectTab(this.tabs[TAB_INDEX.DETAILS]);
        this.actions.setSelectedSeriesContainerSeasons(values(this.state.selectedProduct.ReferencedProducts));
        this.actions.clearSavedSeasonsSelections();
      }
    }
  }, {
    key: "_isServiceFeatureInEditMode",
    value: function _isServiceFeatureInEditMode() {
      var _this3 = this;
      var isEditMode = null;
      isEditMode = !!(this.state.submitChangeOfServiceForServiceFeatureRequest.AddItems || []).find(function (item) {
        return item.ProductId === _this3.state.selectedProductId;
      });
      if (!isEditMode) {
        var removeItems = this.state.submitChangeOfServiceForServiceFeatureRequest.RemoveItems.filter(function (item) {
          return item.ProductId === _this3.state.selectedProductId;
        });
        var numExisting = this.state.featureOrderQuantities && this.state.featureOrderQuantities.length ? this.state.featureOrderQuantities.filter(function (quantity) {
          return quantity.productId === _this3.state.selectedProductId;
        }) : [];
        isEditMode = numExisting.length > removeItems.length;
      }
      return isEditMode;
    }
  }, {
    key: "_addDbssProductsToCart",
    value: function _addDbssProductsToCart(products) {
      var model = {
        products: splitIndividualProducts(products),
        customerId: this.state.currentCustomer.Id,
        shoppingCart: this.state.shoppingCart
      };

      // DBSS products need to be split out individually and not combined
      return this.actions.addMultipleAndUpdateShoppingCart(model, DBSS_UPDATE_CART_ADDITIONAL_OPTIONS);
    }
  }, {
    key: "_prepMultipleItemsForCart",
    value: function _prepMultipleItemsForCart(products) {
      var _this4 = this;
      // DBSS at the moment does not support coupon code so don't think any code related to coupon codes is needed
      var couponCodes = pluck('name', this.state.couponCodes);
      this._addedProducts = products;
      var model = {
        products: products,
        customerId: this.state.currentCustomer.Id,
        shoppingCart: this.state.shoppingCart,
        redemptionCodes: couponCodes || []
      };
      if (this.state.shoppingCart && this.itemExistsInCart()) {
        this.isEditMode = true;
      }
      if (this.state.isSelectedProductServiceFeature) {
        var shoppingCart = processServiceFeatures(this.state.selectedProductId, this.state.selectedProduct, this.pricingPlans, this.state.shoppingCart, this.state.featureOrderQuantities, this.state.routeParams, this.state.orders, this.state.submitChangeOfServiceForServiceFeatureRequest);
        this.actions.updateServiceFeatureQuantityPromise({
          AddItems: shoppingCart.AddItems,
          RemoveItems: shoppingCart.RemoveItems
        });
        model.shoppingCart = shoppingCart;
        model.products = [];
      }
      return (this.isEditMode ? this.actions.editMultipleAndUpdateShoppingCart(model, DBSS_UPDATE_CART_ADDITIONAL_OPTIONS) : this.actions.addMultipleAndUpdateShoppingCart(model, DBSS_UPDATE_CART_ADDITIONAL_OPTIONS)).then(function () {
        if (_this4.state.isSelectedProductServiceFeature) {
          _this4.savedServiceFeatureModel = model;
        }
      });
    }
  }, {
    key: "_setDefaultValuesForInstanceProperties",
    value: function _setDefaultValuesForInstanceProperties() {
      var _this5 = this;
      if (this.state.selectedProduct.InstanceProperties) {
        this.state.selectedProduct.InstanceProperties.map(function (instanceProp) {
          if (!_this5._instanceProperties[instanceProp.Id]) {
            if (equals(GIFT_CARD_INSTANCE_PROPERTY_NAMES.SENDER_NAME, instanceProp.Name)) {
              _this5._instanceProperties[instanceProp.Id] = "".concat(_this5.state.currentCustomer.FirstName, " ").concat(_this5.state.currentCustomer.LastName);
            } else if (equals(GIFT_CARD_INSTANCE_PROPERTY_NAMES.SENDER_EMAIL, instanceProp.Name)) {
              _this5._instanceProperties[instanceProp.Id] = _this5.state.currentCustomer.Email;
            }
          }
        });
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges() {
      // TODO (CustomerOrder): Do not bind to state or modify state. This should only be done through actions.
      if (this.selectedPricingPlanId) {
        if (!isNil(this.state) && !isNil(this.state.optionalProductConfiguration)) {
          this.state.optionalProductConfiguration.mappedPricingPlanId = this.selectedPricingPlanId;
        }
        if (!isNil(this.state) && !isNil(this.state.picklistProductConfiguration)) {
          this.state.picklistProductConfiguration.mappedPricingPlanId = this.selectedPricingPlanId;
        }
      }
    }
  }, {
    key: "_getBundleProductIds",
    value: function _getBundleProductIds() {
      var children = this.state.individualEpisodeConfiguration.items.concat(this.state.optionalProductConfiguration.items || []).concat(this.state.includedProducts || []);
      return children.map(function (child) {
        return child.product.Id;
      });
    }
  }, {
    key: "_initializeOrUpdateComponentData",
    value: function _initializeOrUpdateComponentData() {
      // TODO (CustomerOrder): Do not bind to state or modify state. This should only be done through actions.
      if (this.state.optionalProductConfiguration && this.selectedPricingPlanId) {
        this.state.optionalProductConfiguration.mappedPricingPlanId = this.selectedPricingPlanId;
        this.state.picklistProductConfiguration.mappedPricingPlanId = this.selectedPricingPlanId;
      }
      if (this.state.includedProducts) {
        this.hasIncludedWithInstanceProperties = this.state.includedProducts.some(function (prod) {
          return !isNil(prod.product.InstanceProperties) && !isEmpty(prod.product.InstanceProperties);
        });
        this.hasIncludedWithoutInstanceProperties = this.state.includedProducts.some(function (prod) {
          return isNil(prod.product.InstanceProperties) || isEmpty(prod.product.InstanceProperties);
        });
      }
    }
  }, {
    key: "_selectTab",
    value: function _selectTab(selectedTab) {
      this.tabs.forEach(function (tab) {
        tab.active = tab.name === selectedTab.name;
      });
    }
  }, {
    key: "isModifyMode",
    value: function isModifyMode() {
      // modify mode is not set on state until checkout page, also need to pass in is-modify from modify.modal
      return this.state.isModifyingMode || this.isModify;
    }
  }, {
    key: "handleChangeEpisodicBundle",
    value: function handleChangeEpisodicBundle() {
      var _this6 = this;
      // Save selections when leaving a episodic bundle
      if (this.state.selectedProduct.Id !== this.state.selectedSeriesContainerProductId) {
        this.actions.saveSeriesContainerSeasonSelections(this.state.selectedProduct.Id, this.selectedPricingPlanId, !this.selectedPricingPlanId && this.selectedIndividualEpisodes && this.selectedIndividualEpisodes.items ? this.selectedIndividualEpisodes.items.map(function (episode) {
          return {
            productId: episode.product.Id,
            pricingPlanId: episode.selectedPlanId
          };
        }) : null, this.quantity);
      }
      if (!this.selectedEpisodicBundle) {
        // set the selected product id back to the series container
        this.actions.setSelectedProductId(this.state.selectedSeriesContainerProductId);
        this.tabs.pop();
        this._selectTab(this.tabs[TAB_INDEX.DETAILS]);
      } else {
        if (this.tabs.length === 1) {
          this.tabs.push({
            name: i18n.translate(this.LocaleKeys.PRODUCT_OPTIONS.OPTIONS),
            active: false
          });
          this._selectTab(this.tabs[TAB_INDEX.OPTIONS]);
        }

        // set the selected product to the episodic bundle
        this.actions.setSelectedProductId(this.selectedEpisodicBundle);

        // episodic bundle has been visited before, no need to retrieve data again
        if (!this.state.productsWithMetadataMap[this.selectedEpisodicBundle]) {
          // get the episode bundle and related episodes data
          this.actions.getOrderablePricingExtended(this.selectedEpisodicBundle, this.state.currentCustomer.Id, this.state.searchCouponCode, this.state.routeParams.serviceTypeId).then(function () {
            _this6.initSeasonData();
            var childProductIds = _this6._getBundleProductIds();
            if (childProductIds.length) {
              _this6.actions.getProductMetadataBatch(childProductIds);
            }
            _this6.resetSeasonData();
          });
        } else {
          this.initSeasonData();
          // check if we have saved this season selections before
          if (this.state.hasSavedSeason) {
            if (this.state.savedOtherSeasonSelections[this.selectedEpisodicBundle].pricingPlanId) {
              // hydrate season pricing plan selection
              this.selectedPricingPlanId = clone(this.state.savedOtherSeasonSelections[this.selectedEpisodicBundle].pricingPlanId);
              this.selectIndividualEpisodes = false;
              this.selectedIndividualEpisodes = null;
            } else {
              // hydrate season episode selections in selector for episode view model
              this.selectedPricingPlanId = null;
              this.selectIndividualEpisodes = true;
              if (!this.selectedIndividualEpisodes) {
                this.selectedIndividualEpisodes = {};
              }
              this.selectedIndividualEpisodes.items = clone(this.state.individualEpisodeConfiguration.items.filter(propEq(true, 'isSelected')));
            }
            this.quantity = clone(this.state.savedOtherSeasonSelections[this.selectedEpisodicBundle].quantity);
          } else {
            // no saved season data, reset to no selections
            this.resetSeasonData();
          }
        }
      }
    }
  }, {
    key: "initSeasonData",
    value: function initSeasonData() {
      this.removeSelectedPlanIfNotAvailable();
      this.pricingPlans = this.getPricingPlans();
      this._setDefaultValuesForInstanceProperties();
    }
  }, {
    key: "resetSeasonData",
    value: function resetSeasonData() {
      this.quantity = 1;
      this.selectedPricingPlanId = null;
      this.selectIndividualEpisodes = false;
      this.selectedIndividualEpisodes = null;
    }
  }, {
    key: "getSeriesContainerCurrentSeasonSelectionCount",
    value: function getSeriesContainerCurrentSeasonSelectionCount() {
      return this.state.otherSeasonSelectionCount + (this.selectedPricingPlanId ? this.quantity : this.selectedIndividualEpisodes && this.selectedIndividualEpisodes.items ? this.selectedIndividualEpisodes.items.length * this.quantity : 0);
    }
  }, {
    key: "getSubmitButtonLabel",
    value: function getSubmitButtonLabel() {
      return this.tabs[TAB_INDEX.DETAILS].active ? i18n.translate(this.LocaleKeys.SELECT_OPTIONS) : this.submitLabel || i18n.translate(this.state.isReplacingMode ? this.LocaleKeys.SUBSCRIPTIONS.REPLACE : this.isEditMode ? this.LocaleKeys.CART.SUBMIT_UPDATE : this.state.isSelectedProductSeriesContainer && this.getSeriesContainerCurrentSeasonSelectionCount() ? this.LocaleKeys.ADD_TO_CART_WITH_COUNT : this.LocaleKeys.ADD_TO_CART, {
        count: this.getSeriesContainerCurrentSeasonSelectionCount()
      });
    }
  }, {
    key: "getPricingPlans",
    value: function getPricingPlans() {
      var _this7 = this;
      var plans = pathOr([], ['ProductContext', 'OrderablePricingPlans'], this.state.selectedProduct);
      return clone(this.isModifyMode() ? this.filterOutUnavailablePlans(this.state.pricingPlansForModifySubscription) : plans || this.state.selectedProduct.PricingPlans).filter(function (pricingPlan) {
        if (_this7.state.isSelectedProductServiceFeature) {
          if (pricingPlan.AssociatedServices && pricingPlan.AssociatedServices.length) {
            _this7.associatedServices = pricingPlan.AssociatedServices.filter(function (item) {
              return item.Status === OFFER_STATUS_INDICATOR_STATUS.ACTIVE && item.Id.Value === _this7.state.routeParams.serviceTypeId;
            });
          }
          return _this7.associatedServices && _this7.associatedServices.length;
        } else {
          return pricingPlan;
        }
      }).map(function (pricingPlan) {
        var countOfPricingPlan = 0;
        if (_this7.state.isSelectedProductDbss) {
          // TODO: (CustomerOrder) Temporary solution. Proper solution will be to move all of this to a selector.
          var pricingPlanRAndOBRIs = pricingPlan && pricingPlan.PricingPlanBillerRuleInstances ? [].concat(_toConsumableArray(pricingPlan.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances), _toConsumableArray(pricingPlan.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances)) : [];
          if (_this7.state.isSelectedProductServiceFeature) {
            pricingPlan.billerRuleInstances = pricingPlan.BillerRuleInstanceThumbnails.map(function (bri) {
              bri.chargeAmount = bri.Amount;
              bri.discountAmount = bri.DiscountAmount;
              bri.hasDiscount = !!bri.DiscountAmount;
              bri.name = pricingPlanRAndOBRIs.find(function (_ref) {
                var BillerRuleConfigurationId = _ref.BillerRuleConfigurationId;
                return bri.BillerRuleConfigurationId === BillerRuleConfigurationId;
              }).Name;
              bri.isOverrideSelected = false;
              bri.isOverrideable = _this7.hasAdHocOverrideAccess && pricingPlanRAndOBRIs.some(function (pricingPlanBRI) {
                return pricingPlanBRI.Id === bri.Id && pricingPlanBRI.AllowChargeOverride;
              });
              return bri;
            });
          } else {
            pricingPlan.billerRuleInstances = pricingPlanRAndOBRIs.map(function (bri) {
              bri.chargeAmount = pathOr(0, ['BillerRuleInstanceCharges', 0, 'ChargeAmount'], bri);
              bri.discountAmount = pathOr(0, ['BillerRuleInstanceCharges', 0, 'DiscountActualAmount'], bri);
              bri.hasDiscount = !!bri.discountAmount;
              bri.nonDiscountChargeAmount = pathOr(0, ['BillerRuleInstanceCharges', 0, 'NonDiscountChargeAmount'], bri);
              bri.name = pricingPlan.BillerRuleInstances.find(function (_ref2) {
                var BillerRuleConfigurationId = _ref2.BillerRuleConfigurationId;
                return bri.BillerRuleConfigurationId === BillerRuleConfigurationId;
              }).Name;
              bri.isOverrideSelected = false;
              bri.isOverrideable = _this7.hasAdHocOverrideAccess && pricingPlanRAndOBRIs.some(function (pricingPlanBRI) {
                return pricingPlanBRI.Id === bri.Id && pricingPlanBRI.AllowChargeOverride;
              });
              bri.overriddenAmount = bri.chargeAmount >= 0 ? bri.chargeAmount : bri.chargeAmount * -1;
              return bri;
            });
          }
          _this7.productHasOverrides = !_this7.productHasOverrides ? pricingPlan.billerRuleInstances.some(function (bri) {
            return bri.isOverrideable;
          }) : true;
          if (_this7.state.isSelectedProductAdHoc) {
            pricingPlan.cartQuantity = 0;
          } else {
            if (_this7.state.shoppingCart.Items) {
              _this7.state.shoppingCart.Items.forEach(function (shoppingCartItem) {
                if (shoppingCartItem.PricingPlanId === pricingPlan.Id && shoppingCartItem.ProductId === _this7.state.selectedProduct.Id) {
                  pricingPlan.ShoppingCartItemBillerRuleDetails = clone(shoppingCartItem.ShoppingCartItemBillerRuleDetails);
                  countOfPricingPlan += shoppingCartItem.Quantity;
                }
              }) || {};
            }
            pricingPlan.cartQuantity = countOfPricingPlan;
          }
        } else {
          // NonDBSS pricing plans
          pricingPlan.availabilityDate = getPricingPlanAvailabilityDate(pricingPlan.AvailabilityStart);
        }
        return pricingPlan;
      });
    }
  }, {
    key: "filterOutUnavailablePlans",
    value: function filterOutUnavailablePlans(availablePricingPlanIds) {
      var plans = pathOr([], ['ProductContext', 'OrderablePricingPlans'], this.state.selectedProduct);
      return innerJoin(function (plan, availableId) {
        return plan.Id === availableId;
      }, plans, availablePricingPlanIds);
    }
  }, {
    key: "itemExistsInCart",
    value: function itemExistsInCart() {
      var _this8 = this;
      return (this.state.shoppingCart.Items || []).find(function (item) {
        return item.ProductId === _this8.state.selectedProductId;
      });
    }
  }, {
    key: "_getTabByNameOrDefault",
    value: function _getTabByNameOrDefault(name) {
      return name === i18n.translate(this.LocaleKeys.PRODUCT_OPTIONS.OPTIONS) ? this.tabs[TAB_INDEX.OPTIONS] : this.tabs[TAB_INDEX.DETAILS];
    }
  }, {
    key: "hasSelectableProducts",
    value: function hasSelectableProducts(configuration) {
      var _this9 = this;
      if (isNil(configuration) || isNil(this.selectedPricingPlanId) || isNil(configuration.items) || configuration.items.length === 0) {
        return false;
      }
      return configuration.items.some(function (selectableItem) {
        if (!selectableItem.pricingPlans) {
          return false;
        }
        return selectableItem.pricingPlans[_this9.selectedPricingPlanId];
      });
    }
  }, {
    key: "shouldShowDetails",
    value: function shouldShowDetails() {
      return this.tabs[TAB_INDEX.DETAILS].active;
    }
  }, {
    key: "shouldShowLoadingIndicator",
    value: function shouldShowLoadingIndicator() {
      return this.state.isFetchingOrderableProductData || this.state.isFetchingSingleProductContext || !this.pricingPlans || this.state.isCalculatingQuote;
    }
  }, {
    key: "_getFormSubmitAction",
    value: function _getFormSubmitAction() {
      if (this.isModifyMode() || this.state.isReplacingMode) {
        return this._calculateModifyOrderQuote.bind(this);
      } else if (this.isEditMode && !this.state.isSelectedProductServiceFeature) {
        return this._editProductInCart.bind(this);
      } else if (this.state.isSelectedProductServiceFeature) {
        return this._prepMultipleItemsForCart.bind(this);
        // TODO Customer Order long term we should have a Shared function for DBSS products as behavior will be the same for now just starting with ad hoc
      } else if (this.state.isSelectedProductAdHoc) {
        return this._addDbssProductsToCart.bind(this);
      } else {
        return this._addProductToCart.bind(this);
      }
    }
  }, {
    key: "handleSubmitForm",
    value: function handleSubmitForm() {
      var _this10 = this;
      if (this.tabs[TAB_INDEX.DETAILS].active) {
        if (!this.formSubmittedFromOptionsTab) {
          // reset the form if it wasn't previously submitted, so the first visit to the options tab
          // doesn't show validation errors, but any prior errors will remain
          this.formApi.$setPristine();
        }
        this._selectTab(this.tabs[TAB_INDEX.OPTIONS]);
      } else if (this._noItemsModified()) {
        this.uiNotificationService.error(i18n.translate(this.LocaleKeys.CART.NO_CHANGED_ITEMS));
      } else if (this.isExceededCartMaximumQuantity) {
        this.$anchorScroll('quantityItemsErrorField');
      } else if (this.formApi.$valid && !this.isExceededCartMaximumQuantity) {
        this.formSubmittedFromOptionsTab = true;
        for (var key in this._instanceProperties) {
          if (this._instanceProperties[key] === '' || isNil(this._instanceProperties[key])) {
            delete this._instanceProperties[key];
          }
        }
        var submitFn = this._getFormSubmitAction();
        if (this.state.isSelectedProductAdHoc) {
          this.shoppingCartForServiceFeatures = this.shoppingCartForServiceFeatures.map(function (cartItem) {
            var matchingPricingPlan = _this10.pricingPlans.find(function (pricingPlan) {
              return pricingPlan.Id === cartItem.pricingPlanId;
            });
            var localBRIData = matchingPricingPlan.billerRuleInstances.length ? matchingPricingPlan.billerRuleInstances[0] : null;
            return {
              adHocOverrideDetails: !localBRIData.isOverrideSelected ? undefined : {
                // Keep Amounts's polarity the same when submitting to the API
                Amount: Math.abs(localBRIData.chargeAmount) === Math.abs(localBRIData.overriddenAmount) ? undefined : localBRIData.chargeAmount <= 0 && localBRIData.Credit ? localBRIData.overriddenAmount * -1 : convertStringToNumber(localBRIData.overriddenAmount),
                InvoiceText: localBRIData.overriddenName
              },
              childItems: cartItem.childItems,
              pricingPlanId: cartItem.pricingPlanId,
              productId: cartItem.productId,
              quantity: cartItem.quantity
            };
          });
        }

        // TODO Customer Order refactor later to handle for DBSS Products as a whole, not individually for SF, Adhoc, & later Standalones
        // TODO Customer Order shoppingCartForServiceFeatures will be Shared for DBSS products with collection of pricing plans with quantities
        return submitFn(this.state.isSelectedProductServiceFeature || this.state.isSelectedProductAdHoc ? this.shoppingCartForServiceFeatures : this.selectedPricingPlanId).then(function (shoppingCart) {
          if (_this10.state.invalidItems.length > 0 || shoppingCart === FAILED_CALL) {
            var failureCallbackFn = _this10.onFailure();
            failureCallbackFn && failureCallbackFn(shoppingCart, _this10.state.invalidItems);
          } else {
            var successCallbackFn = _this10.onSuccess();
            successCallbackFn && successCallbackFn(shoppingCart, _this10._addedProducts, false, _this10.savedServiceFeatureModel);
          }
          _this10._closeDialog();
        }).catch(function () {
          if (_this10.state.isSelectedProductServiceFeature) {
            var failureCallbackFn = _this10.onFailure();
            failureCallbackFn && failureCallbackFn(undefined, _this10.state.invalidItems, true);
          }
        });
      }
    }
  }, {
    key: "clearSelectedPricingPlan",
    value: function clearSelectedPricingPlan() {
      if (this.selectIndividualEpisodes) {
        this.selectedPricingPlanId = null;
        // TODO (CustomerOrder): Do not bind to state or modify state. This should only be done through actions.
        this.state.optionalProductConfiguration.mappedPricingPlanId = null;
        this.state.picklistProductConfiguration.mappedPricingPlanId = null;
      }
    }
  }, {
    key: "clearNonPricingPlanSelections",
    value: function clearNonPricingPlanSelections(pricingPlanId) {
      this.selectIndividualEpisodes = false;
      // TODO (CustomerOrder): Do not bind to state or modify state. This should only be done through actions.
      this.state.optionalProductConfiguration.mappedPricingPlanId = pricingPlanId;
      this.state.picklistProductConfiguration.mappedPricingPlanId = pricingPlanId;
    }
  }, {
    key: "_addProductToCart",
    value: function _addProductToCart(pricingPlanId) {
      var _this11 = this;
      var couponCode = this.state.searchCouponCode;
      if (couponCode) {
        if (!this.state.couponCodes.find(propEq(couponCode, 'name'))) {
          // only apply the coupon if it's unique (not already applied)
          this.actions.setProductOrderCouponCodes([{
            name: couponCode,
            description: null
          }].concat(this.state.couponCodes));
        }
      }
      // ToDo: (CutomerOrder): Move to a selector so it's memoized
      var currentCouponCodes = pluck('name', this.state.couponCodes);
      var couponCodes = couponCode ? currentCouponCodes.concat([couponCode]) : currentCouponCodes;
      if (this.selectIndividualEpisodes || this.state.hasOtherSavedSeasonSelections) {
        // Get selection from other seasons if any
        var products = this.state.hasOtherSavedSeasonSelections ? this.state.otherSeasonsProductsToAdd : [];
        // Add current selection of episodes or full season
        if (this.selectIndividualEpisodes && !isNil(this.selectedIndividualEpisodes) && this.selectedIndividualEpisodes.items.length) {
          products = products.concat(this.selectedIndividualEpisodes.items.map(function (episode) {
            var result = {
              productId: episode.product.Id,
              pricingPlanId: episode.selectedPlanId,
              quantity: _this11.quantity
            };
            var instanceProps = _this11.selectedIndividualEpisodes.instanceProperties[episode.product.Id];
            if (!isNil(instanceProps)) {
              result.instanceProperties = instanceProps;
            }
            return result;
          }));
        } else {
          products = products.concat({
            productId: this.state.isSelectedProductSeriesContainer ? this.state.selectedProduct.Id : this.state.selectedProductId,
            pricingPlanId: pricingPlanId,
            quantity: this.quantity
          });
        }
        this._addedProducts = products;
        var model = {
          products: products,
          customerId: this.state.currentCustomer.Id,
          shoppingCart: this.state.shoppingCart,
          redemptionCodes: couponCodes || []
        };
        return this.actions.addMultipleAndUpdateShoppingCart(model);
      } else {
        var product = {
          childItems: [],
          customerId: this.state.currentCustomer.Id,
          instanceProperties: this._instanceProperties,
          pricingPlanId: pricingPlanId,
          productId: this.state.isSelectedProductSeriesContainer ? this.state.selectedProduct.Id : this.state.selectedProductId,
          quantity: this.quantity,
          redemptionCodes: couponCodes || [],
          shoppingCart: this.state.shoppingCart,
          standalone: this.state.selectedProduct.Standalone || undefined
        };
        this._populateBundleChildren(product, pricingPlanId);
        this._addedProducts = [{
          productId: this.state.selectedProductId,
          pricingPlanId: pricingPlanId
        }];
        return this.actions.addToAndUpdateShoppingCart(product);
      }
    }
  }, {
    key: "_editProductInCart",
    value: function _editProductInCart(updatedPricingPlanId) {
      var _this12 = this;
      var product = {
        pricingPlanId: updatedPricingPlanId,
        childItems: []
      };
      this._populateBundleChildren(product, updatedPricingPlanId);
      this._addedProducts = [{
        pricingPlanId: updatedPricingPlanId,
        productId: this.state.selectedProductId
      }];
      var couponCodes = pluck('name', this.state.couponCodes);
      return this.actions.editAndUpdateShoppingCart({
        index: this.state.selectedShoppingCartItemIndex,
        product: product,
        quantity: this.quantity,
        instanceProperties: this._instanceProperties,
        customerId: this.state.currentCustomer.Id,
        shoppingCart: this.state.shoppingCart,
        redemptionCodes: couponCodes || []
      }).then(function (responseData) {
        _this12.actions.setShoppingCartItemIndex(null);
        return responseData;
      });
    }
  }, {
    key: "_getBaseSubscriptionOrderData",
    value: function _getBaseSubscriptionOrderData(pricingPlanId) {
      var updatedSubscriptionItem = {
        productId: this.state.selectedProductId,
        pricingPlanId: pricingPlanId,
        childItems: [],
        quantity: this.quantity,
        instanceProperties: this._instanceProperties
      };
      this._populateBundleChildren(updatedSubscriptionItem, pricingPlanId);
      updatedSubscriptionItem = pascalCaseKeys(updatedSubscriptionItem);
      return updatedSubscriptionItem;
    }
  }, {
    key: "_noItemsModified",
    value: function _noItemsModified() {
      if (!this.isModifyMode()) {
        return false;
      }
      var updatedSubscriptionItem = this._getBaseSubscriptionOrderData(this.selectedPricingPlanId);
      // TODO - Customer Order move to selectors for memoization and uniting, don't need to run this code repeatedly
      var existingChildren = pathOr([], ['state', 'editSubscriptionItem', 'Children'], this);
      var editItems = getEditItems(updatedSubscriptionItem, existingChildren, this.state.editSubscriptionItem);
      return noItemsModified(editItems);
    }
  }, {
    key: "_getRequestDataForModifyOrderQuote",
    value: function _getRequestDataForModifyOrderQuote(pricingPlanId) {
      var updatedSubscriptionItem = this._getBaseSubscriptionOrderData(pricingPlanId);
      var editItems = {};
      var replaceItems = [];
      if (this.state.isReplacingMode) {
        var currentSubscriptionItemToReplaceId = pathOr(null, ['replaceItem', 'id'], this.state);
        this.actions.setReplacementItem(updatedSubscriptionItem);
        replaceItems = getReplaceItems(updatedSubscriptionItem, currentSubscriptionItemToReplaceId);
      } else {
        // TODO - Customer Order move to selectors for memoization and uniting, don't need to run this code repeatedly
        var existingChildren = pathOr([], ['state', 'editSubscriptionItem', 'Children'], this);
        editItems = getEditItems(updatedSubscriptionItem, existingChildren, this.state.editSubscriptionItem);
      }
      return {
        customerId: this.state.currentCustomer.Id,
        calculateShipping: false,
        calculateTaxes: false,
        useDefaults: false,
        modificationObject: {
          ChangeImmediately: this.state.changeImmediately,
          AddItems: editItems.addItems || [],
          ChangeItems: editItems.changeItems || [],
          RemoveItems: editItems.removeItems || [],
          ReplaceItems: replaceItems,
          SubscriptionId: this.state.currentSubscription.Id
        },
        paymentInstrumentIds: this.state.paymentInstrumentIds || [],
        redemptionCodes: this.state.searchCouponCode ? [this.state.searchCouponCode] : []
      };
    }
  }, {
    key: "_calculateModifyOrderQuote",
    value: function _calculateModifyOrderQuote(pricingPlanId) {
      var _this13 = this;
      var reqData = this._getRequestDataForModifyOrderQuote(pricingPlanId);
      return this.actions.calculateModifyOrderQuote(reqData).then(function (respData) {
        if (respData && respData.faultCode) {
          return FAILED_CALL;
        } else {
          return _this13.state.shoppingCart;
        }
      });
    }
  }, {
    key: "_closeDialog",
    value: function _closeDialog() {
      this.removeSelectedPlanIfNotAvailable();
      this.actions.setShoppingCartItemIndex(null);
      this.formApi.$setPristine();
      this.actions.clearSelectedOptions();
      var onClose = this.onClose();
      onClose && onClose();
    }
  }, {
    key: "hasAdditionalEpisodes",
    value: function hasAdditionalEpisodes() {
      return this.state.remainingEpisodicProductIds.length > 0 && this.state.includedEpisodes.length > 0;
    }
  }, {
    key: "fetchAdditionalEpisodes",
    value: function fetchAdditionalEpisodes() {
      var _this14 = this;
      return this.actions.loadAdditionalEpisodes(this.state.currentCustomer.Id, this.state.selectedProductId, {
        EpisodicChildProducts: this.state.remainingEpisodicProductIds.slice(0, 50),
        IncludeOrderablePricingPlans: true
      }).then(function () {
        var episodeIds = _this14.state.individualEpisodeConfiguration.items.map(function (item) {
          return item.product.Id;
        });
        _this14.actions.getProductMetadataBatch(episodeIds);
      }).catch(function (error) {
        _this14.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "pricingPlanDoesNotExist",
    value: function pricingPlanDoesNotExist(plans) {
      var _this15 = this;
      return none(function (plan) {
        return plan.Id === _this15.selectedPricingPlanId;
      }, plans);
    }
  }, {
    key: "removeSelectedPlanIfNotAvailable",
    value: function removeSelectedPlanIfNotAvailable() {
      var plans = pathOr([], ['ProductContext', 'OrderablePricingPlans'], this.state.selectedProduct);
      if (this.pricingPlanDoesNotExist(plans)) {
        delete this.selectedPricingPlanId;
      }
    }
  }, {
    key: "_populateBundleChildren",
    value: function _populateBundleChildren(product, pricingPlanId) {
      var _this16 = this;
      this.selectedOptionalItems = this.selectedOptionalItems || {};
      this.selectedPicklistItems = this.selectedPicklistItems || {};
      var optional = this.selectedOptionalItems.items || [];
      var picklist = this.selectedPicklistItems.items || [];
      if (this.state.includedProducts.length) {
        this.state.includedProducts.forEach(function (includedProduct) {
          var qty = includedProduct.bundle.MinimumQuantity;
          var childItem = {
            BundleId: includedProduct.bundle.Id,
            ProductId: includedProduct.product.Id,
            PricingPlanId: includedProduct.pricingPlans[pricingPlanId].Id,
            Quantity: qty > 0 ? qty : 1
          };
          var instanceProps = _this16.includedProductInstanceProperties[includedProduct.product.Id];
          if (!isNil(instanceProps) && !isEmpty(instanceProps)) {
            childItem.InstanceProperties = instanceProps;
          }
          product.childItems.push(childItem);
        });
      }
      optional.forEach(function (child) {
        var qty = Number(child.quantity);
        if (!isNil(child.pricingPlans[pricingPlanId])) {
          var childItem = {
            BundleId: child.bundle.Id,
            ProductId: child.product.Id,
            PricingPlanId: child.pricingPlans[pricingPlanId].Id,
            Quantity: isNaN(qty) ? 1 : qty
          };
          var instanceProps = _this16.selectedOptionalItems.instanceProperties[child.product.Id];
          if (!isNil(instanceProps) && !isEmpty(instanceProps)) {
            childItem.InstanceProperties = instanceProps;
          }
          product.childItems.push(childItem);
        }
      });
      picklist.forEach(function (child) {
        var qty = Number(child.quantity);
        if (!isNil(child.pricingPlans[pricingPlanId])) {
          product.childItems.push({
            BundleId: child.bundle.Id,
            ProductId: child.product.Id,
            PricingPlanId: child.pricingPlans[pricingPlanId].Id,
            Quantity: isNaN(qty) ? 1 : qty
          });
        }
      });
    }
  }, {
    key: "productMaxQuantity",
    get: function get() {
      return pathOr(true, ['isSelectedProductServiceFeature'], this.state) ? this.state.selectedProduct.ProductContext.ServiceFeatureCardinality.MaximumQuantity || this.MAX_SERVICE_FEATURE_ITEMS : pathOr(0, ['selectedProduct', 'MaxNonBulkQuantity'], this.state);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      if (this.state.productDialogErrorMessages) {
        this.actions.clearShoppingCartError();
      }
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./product.dialog.html'),
  controller: ProductDialogController,
  bindings: {
    dialogSize: '<?',
    isModify: '<?',
    onClose: '&',
    onDialogPopulated: '&',
    onFailure: '&',
    onSuccess: '&',
    selectedTab: '<',
    submitLabel: '<?'
  }
};